module.exports = __webpack_public_path__ + "img/Dantam Fashion 16.0984d3e5.jpg";